<template>
	<div class="readonly-field">
		<label for="" class="readonly-field__label"
			><span class="readonly-field__label-text">{{ label }}</span>
			<IconInfo
				v-if="textIconInfo"
				position="top"
				:text="textIconInfo"
			></IconInfo
		></label>

		<div class="readonly-field__content">
			<span class="readonly-field__content-text" v-if="text.length">{{
				text
			}}</span>
			<span
				class="readonly-field__content-additional"
				v-if="$slots.subContent"
			>
				<slot name="subContent" />
			</span>
		</div>
	</div>
</template>

<script>
import IconInfo from '@/components/notifications/icon-info/icon-info';
export default {
	name: 'ReadonlyField',
	components: {
		IconInfo
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		textIconInfo: {
			type: String,
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.readonly-field {
	display: grid;
	grid-template-columns: 140px 1fr;
	column-gap: $gutter-md;
	@include body-text('regular');

	&:not(:last-child) {
		margin-bottom: $gutter-lg;
	}

	&__label {
		display: flex;
		flex-direction: row;
		gap: $gutter-sm;
		align-items: baseline;
		color: $neutral-2;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: $gutter-sm;
	}
}
</style>
